import { IDocumentTable } from '@models/Document.model';
import { DocumentsFieldConfigurationTypeOptions } from '@models/DocumentTable.model';
import { DATE_FORMAT_EXPANDED } from '@utils/getEquipmentvalue/getEquipmentValue';
import { format } from 'date-fns';

export function getDocumentValue(
  fieldName: DocumentsFieldConfigurationTypeOptions,
  document: IDocumentTable,
) {
  let value = document[fieldName];

  if (value instanceof Date) {
    value = format(value, DATE_FORMAT_EXPANDED);
  }
  return value || '';
}
